import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae5dcf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增采购单")
const _hoisted_5 = ["onDblclick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("附件")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下载明细")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, " 点击/拖拽上传 ", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("上传支付文件")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, reactive, onBeforeMount, onMounted} from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatNumber, getNumber,exportHandle} from '@/utils/index'
import Api from '@/http/modules/index'
import dayjs from "dayjs"

export default /*#__PURE__*/_defineComponent({
  emits: ['through','updateProcures'],
  setup(__props, { emit }) {

const {
    // 采购付款汇总
    'POST/procures/page':procuresPageApi,
    // 新增-采购单
    'POST/procures':procuresAddApi,
    // 修改-采购单
    'PATCH/procures':procuresmodifyApi,
    // 上传-支付文件(可同时上传多个)
    'POST/procures/upload':procuresUploadApi,
    // 下载附件
    'GET/upload/download': downloadApi,
    // 导出采购付款汇总明细
    'POST/procures/export_detail':exportDetailApi,
    // 获取上传附件列表
    'POST/upload/file_info':uploadFileInfoApi
} = Api

const queryInfo=ref<any>({
    monthRange:[dayjs().startOf('year').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')]
})
const addProcuresLoading=ref<any>(false)
const tableHeight=window.innerHeight-280
const pageInfo=reactive({
    page:1,
    size:30,
    total:0
})
const procuresVisiable=ref(false)

const tableLoad=ref(false)
const procuresList=ref([])
const alias=ref([])
const procuresInfo = ref<any>({})
const searchHandle = (isReset:boolean=false) => {    
    if(isReset){
      pageInfo.page= 1
      queryInfo.value={monthRange:[dayjs().startOf('year').format('YYYY-MM-DD'),dayjs().format('YYYY-MM-DD')]}
    }
    let {page,size}=pageInfo
    let {monthRange}=queryInfo.value
    let params={
        page,size,
        procureDateRange:{
          from:monthRange&&monthRange.length?dayjs(monthRange[0]).format('YYYY-MM-DD'):'',
          to:monthRange&&monthRange.length?dayjs(monthRange[1]).format('YYYY-MM-DD'):''
        }
    }
    tableLoad.value=true
    procuresPageApi(params).then((res:any)=>{
        procuresList.value=res.data
        pageInfo.total=res.rowCount
        alias.value=res.alias
    }).finally(()=>{
        tableLoad.value=false
    })
}
const procuresHandle=(data = {})=>{
    procuresInfo.value = JSON.parse(JSON.stringify(data))
    procuresVisiable.value = true
}
const addHandle=()=>{
    let {name,date,id}=procuresInfo.value
    if(!name||!date){
        ElMessage.warning(!name?'请输入采购单名称':'请选择日期')
        return
    }
    let params={
        name,date:dayjs(date).format('YYYY-MM-DD'),fileIds:[],id
    }
    addProcuresLoading.value=true
    const handleApi=id?procuresmodifyApi:procuresAddApi
    handleApi(params).then(()=>{
        ElMessage.success(id?"修改成功":"添加成功")
        procuresVisiable.value=false
        searchHandle()
        emit('updateProcures')
    }).finally(()=>{
        addProcuresLoading.value=false
    })
}
const filterAmount = (data: any[], alias: string) => {
  if(!data || data.length === 0) return "-";

  let res = data.find((el: {alias: string}) => el.alias === alias)
  return getNumber(res?.amount)
}

// 批量导入
const batchUploadVisiable=ref(false)
const fileList=ref<any>([])
const batchUploadRef=ref()
const batchUploadLoading=ref(false)
const uploadNote=ref('')
const currentUploadId=ref('')
const batchUploadHandle=(row:any)=>{
    batchUploadVisiable.value=true
    currentUploadId.value=row.id
}
const bantchUploadMethod=()=>{
    if(!fileList.value.length){
        ElMessage.warning('请选择要上传的文件')
        return
    }
    const formData = new FormData()
    formData.append('id',currentUploadId.value)
    formData.append('note',uploadNote.value)
    fileList.value.forEach((file:any)=>{
        formData.append(`file`,file.raw)
    })
    batchUploadLoading.value=true
    procuresUploadApi(formData).then((res:any)=>{
        batchUploadVisiable.value=false
        ElMessage.success('上传成功')
        getFileLists(res.fileIds)
    }).finally(()=>{
        batchUploadLoading.value=false
    })
}
const resetBatchUpload=()=>{
    fileList.value=[]
    batchUploadRef.value.clearFiles()
    uploadNote.value=""
    currentUploadId.value=""
}
const uploadedFileList=ref([])
const filesVisiable=ref(false)
const currentOpsData=ref<any>({})
const uploadFileListLoading=ref(false)
const fileHandle=(row:any)=>{
    // uploadedFileList.value=row.fileList
    filesVisiable.value=true
    currentOpsData.value=row
    getFileLists(row.fileIds)
}
const getFileLists=(ids:any)=>{
    uploadFileListLoading.value=true
    uploadFileInfoApi({fileIds:ids,page:1,size:50}).then((res:any)=>{
      uploadedFileList.value=res.data
    }).finally(()=>{
      uploadFileListLoading.value=false
    })
}
const exportDetail=(row:any)=>{
    ElMessageBox.confirm('请确认是否导出采购明细？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
    }).then(() => {
    tableLoad.value=true    
    return exportHandle(exportDetailApi, {procureId: row.id})
  }).finally(() => {
    tableLoad.value=false
  })
}
// 穿透到采购批次
const goProcuresPayment=(procureId:any,domestic:any,companyName:string,datAarr:any)=>{
  if(!datAarr.length)return
  let res = datAarr.find((el: {alias: string}) => el.alias === companyName)
  emit('through',{procureId,domestic,companyId:res.companyId})
}
onMounted(()=>{
  searchHandle()
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Download = _resolveComponent("Download")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      inline: "",
      class: "searchBg",
      disabled: tableLoad.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "采购日期:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              clearable: "",
              modelValue: queryInfo.value.monthRange,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryInfo.value.monthRange) = $event)),
              type: "daterange",
              "range-separator": "到",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (searchHandle()))
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (searchHandle(true)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["disabled"]),
    _hoisted_3,
    _createVNode(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (procuresHandle())),
      type: "primary",
      disabled: tableLoad.value
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: procuresList.value,
      "max-height": tableHeight+'px',
      class: "mt-10 mb-10",
      style: {"width":"100%"},
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "采购付款ID",
          prop: "id",
          width: "100",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "名称",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "采购日期",
          prop: "date",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          label: "合计",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "境外",
              align: "right",
              prop: "abroadTotalAmount",
              "min-width": "140",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "境内",
              align: "right",
              prop: "domesticTotalAmount",
              "min-width": "140",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alias.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: item,
            label: item,
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "境外",
                align: "right",
                "min-width": "140"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: "click-link",
                    onDblclick: ($event: any) => (goProcuresPayment(row.id,0,item,row.abroadList))
                  }, _toDisplayString(filterAmount(row.abroadList,item)), 41, _hoisted_5)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                label: "境内",
                align: "right",
                "min-width": "140"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_link, {
                    onDblclick: ($event: any) => (goProcuresPayment(row.id,1,item,row.domesticList)),
                    underline: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(filterAmount(row.domesticList,item)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onDblclick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "190",
          fixed: "right"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_link, {
              underline: false,
              type: "primary",
              onClick: ($event: any) => (procuresHandle(row))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_link, {
              underline: false,
              onClick: ($event: any) => (fileHandle(row)),
              class: "ml-10"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_link, {
              underline: false,
              onClick: ($event: any) => (exportDetail(row)),
              class: "ml-10"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, tableLoad.value]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      disabled: tableLoad.value,
      "current-page": _unref(pageInfo).page,
      "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_unref(pageInfo).page) = $event)),
      "page-size": _unref(pageInfo).size,
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_unref(pageInfo).size) = $event)),
      "page-sizes": [30, 120, 300, 400,500],
      layout: "sizes, prev, pager, next, total, jumper",
      total: _unref(pageInfo).total,
      onSizeChange: _cache[6] || (_cache[6] = ()=>searchHandle()),
      onCurrentChange: _cache[7] || (_cache[7] = ()=>searchHandle())
    }, null, 8, ["disabled", "current-page", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      width: "600",
      title: '新增采购单',
      onClose: _cache[11] || (_cache[11] = ($event: any) => (procuresInfo.value={})),
      modelValue: procuresVisiable.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((procuresVisiable).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (procuresVisiable.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: addHandle,
          loading: addProcuresLoading.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: "",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称:" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: procuresInfo.value.name,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((procuresInfo.value.name) = $event)),
                  clearable: "",
                  maxlength: "200",
                  placeholder: "请输入名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "日期:" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  clearable: "",
                  modelValue: procuresInfo.value.date,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((procuresInfo.value.date) = $event)),
                  type: "date",
                  placeholder: "请选择日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: batchUploadVisiable.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((batchUploadVisiable).value = $event)),
      onClose: resetBatchUpload,
      center: "",
      title: "批量导入"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: batchUploadLoading.value,
          type: "primary",
          onClick: bantchUploadMethod
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          multiple: "",
          "auto-upload": false,
          ref_key: "batchUploadRef",
          ref: batchUploadRef,
          "file-list": fileList.value,
          "onUpdate:file-list": _cache[13] || (_cache[13] = ($event: any) => ((fileList).value = $event)),
          drag: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
              default: _withCtx(() => [
                _createVNode(_component_upload_filled)
              ]),
              _: 1
            }),
            _hoisted_11
          ]),
          _: 1
        }, 8, ["file-list"]),
        _createVNode(_component_el_input, {
          modelValue: uploadNote.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((uploadNote).value = $event)),
          placeholder: "请输入备注",
          "show-word-limit": "",
          type: "textarea"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: filesVisiable.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((filesVisiable).value = $event)),
      onClose: _cache[19] || (_cache[19] = ($event: any) => (currentOpsData.value={})),
      title: "附件"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (filesVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "mb-10",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (batchUploadHandle(currentOpsData.value))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: uploadedFileList.value,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "上传人",
              width: "120",
              prop: "username"
            }),
            _createVNode(_component_el_table_column, {
              label: "文件名",
              width: "220",
              "show-overflow-tooltip": "",
              prop: "filename"
            }),
            _createVNode(_component_el_table_column, {
              label: "备注",
              prop: "note",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "上传时间",
              width: "180",
              prop: "uploadAt"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "80",
              align: "center"
            }, {
              default: _withCtx(({row}) => [
                _withDirectives((_openBlock(), _createBlock(_component_eptBtn, {
                  type: "primary",
                  exportFn: _unref(downloadApi),
                  exportParam: {fileId: row.fileId, filename: row.filename}
                }, {
                  default: _withCtx(({exportFn, downFg}) => [
                    _createVNode(_component_el_link, {
                      onClick: exportFn,
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: "18" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Download)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["exportFn", "exportParam"])), [
                  [_directive_permission, void 0, "checkin"]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, uploadFileListLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})